import { FirebasePerformanceTypes } from '@react-native-firebase/perf';
import { noop } from 'lodash-es';

// firebase perf doesn't work in web but this wrapper keeps API compatibility the same for what we are using
const getPerformance = (...props: unknown[]) => new MockTrace();
const getApp = () => null;
export { getPerformance, getApp };

class MockTrace {
  start = function () {
    return Promise.resolve();
  };
  startTrace = function (...props: unknown[]) {
    return (Promise.resolve() as unknown) as Promise<FirebasePerformanceTypes.Trace>;
  };
  stop = function () {
    return Promise.resolve() as Promise<void>;
  };
  stopNativeTrace = noop;
  putAttribute = noop;
  putMetric = noop;
  getAttribute = noop;
  getAttributes = noop;
  getMetric = noop;
  incrementMetric = noop;
}

export const trace = (...props: unknown[]) =>
  (new MockTrace() as unknown) as FirebasePerformanceTypes.Trace;
